import { render, staticRenderFns } from "./ContratoClausulas.vue?vue&type=template&id=1c4275fd&scoped=true"
import script from "./ContratoClausulas.vue?vue&type=script&lang=js"
export * from "./ContratoClausulas.vue?vue&type=script&lang=js"
import style0 from "./ContratoClausulas.vue?vue&type=style&index=0&id=1c4275fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4275fd",
  null
  
)

export default component.exports